module.exports = __webpack_public_path__ + "site/img/252.86398e62.jpg";